import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faAngleDown, faAngleUp, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { AiRiskControllerService } from '@set-it-workflow/set-it-workflow-ts-angular/api/aiRiskController.service';
import { ComponentControllerService } from '@set-it-workflow/set-it-workflow-ts-angular/api/componentController.service';
import { DepartmentControllerService } from '@set-it-workflow/set-it-workflow-ts-angular/api/departmentController.service';
import { AiRiskLevelInfo } from '@set-it-workflow/set-it-workflow-ts-angular/model/aiRiskLevelInfo';
import { AiRiskReport } from '@set-it-workflow/set-it-workflow-ts-angular/model/aiRiskReport';
import { ComponentResponse } from '@set-it-workflow/set-it-workflow-ts-angular/model/componentResponse';
import { DepartmentResponse } from '@set-it-workflow/set-it-workflow-ts-angular/model/departmentResponse';
import { AuthService } from 'src/app/service/auth.service';
import { config } from 'src/environments/config';
import { CrReportService } from '../services/cr-report.service';
import { DownloadFileService } from '../services/download-file.service';

@Component({
  selector: 'app-ai-risk',
  templateUrl: './ai-risk.component.html',
  styleUrls: ['./ai-risk.component.scss']
})
export class AiRiskComponent implements OnInit {

  public faAngleUp = faAngleUp;
  public faAngleDown = faAngleDown;
  public faCalendarAlt = faCalendarAlt;

  public itDepartments: DepartmentResponse[] = [];
  public serviceByDeptId: ComponentResponse[] = [];
  public aiRiskResults: AiRiskLevelInfo[] = [];
  public initDefaultItDepartmentId;
  public defaultItDepartmentId;
  
  public isCollapse = false;
  public isSearch = false;

  public hoveredCreatedDate: NgbDate | null = null;
  public hoveredApprovedDate: NgbDate | null = null;

  public reportColumn : String[] = [
    'type','taskID','mainTaskName','serviceName','itDepartment',
    'category1','category2','aiRiskResult','aiRiskStatus','approvedDate','createdDate'
  ];

  public tasks: AiRiskReport[] = [];

  public page = 1;
  public pageSize = 10;
  public totalElements = 0;

  public form: FormGroup = new FormGroup({
    deptId: new FormControl(null, Validators.required),
    serviceIds: new FormControl(),
    createdStartDate: new FormControl(),
    createdEndDate: new FormControl(),
    approvedStartDate: new FormControl(),
    approvedEndDate: new FormControl(),
    aiRiskResult: new FormControl()
  })

  get f() { return this.form.controls; }
  
  constructor(
    private aiRiskService: AiRiskControllerService,
    private departmentService: DepartmentControllerService,
    private componentService: ComponentControllerService,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private downloadFileService: DownloadFileService,
    private _httpClient: HttpClient,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getITDepartments();
    this.getAiRiskLevels();
    this.form.valueChanges.subscribe(() => {
      this.isSearch = false;
    });
  }

  private getITDepartments(): void {
    this.departmentService.getDefaultITDepartmentByUserLoginUsingGET()
    .subscribe(res => {
      this.itDepartments = res.data;
      res.data.forEach(value => {
        if (value.defaultDept) {
          this.defaultItDepartmentId = value.deptID;
          this.initDefaultItDepartmentId = value.deptID;
          if (this.defaultItDepartmentId) {
            this.getComponentByDeptId1(this.defaultItDepartmentId);
          } else {
            this.getComponentByDeptId();
          }
         
        }
      });
    });
  }

  private getComponentByDeptId(): void {
    this.componentService.getComponentsByDeptIdUsingGET(this.f.deptId.value).subscribe(res => {
      this.serviceByDeptId = res.data;
    });
  }

  private getComponentByDeptId1(deptId: string): void {
    this.componentService.getComponentsByDeptIdUsingGET(deptId).subscribe(res => {
      this.serviceByDeptId = res.data;
    });
  }

  private getAiRiskLevels(): void {
    this.aiRiskService.getAiRiskLevelUsingGET().subscribe(res => {
      this.aiRiskResults = res.data;
    });
  }

  public clear(): void {
    this.form.reset();
    this.form.controls.deptId.setValue(this.initDefaultItDepartmentId);
    this.getComponentByDeptId1(this.initDefaultItDepartmentId);
    this.tasks = [];
    this.page = 1;
    this.totalElements = 0;
  }

  public search(): void {
    this.form.markAllAsTouched();
    console.log(this.form);

    if (!this.form.invalid) {
      this.page = 1;
      this.getTasks();
    }
  }

  private getTasks(): void {
    let form = this.form.getRawValue();
    this.aiRiskService.getAiRiskReportUsingGET(
      this.f.deptId.value, 
      this.f.aiRiskResult.value, 
      this.f.approvedEndDate ? this.formatter.format(form.approvedEndDate) : null,
      this.f.approvedStartDate ? this.formatter.format(form.approvedStartDate) : null,
      this.f.createdEndDate ? this.formatter.format(form.createdEndDate) : null,
      this.f.createdStartDate ? this.formatter.format(form.createdStartDate) : null,
      this.page - 1, 
      this.f.serviceIds.value, 
      this.pageSize, 
      null
    ).subscribe(res => {
      this.tasks = res.data.elements;
      this.totalElements = res.data.totalElements;
      this.isSearch = true;
    });
  }

  public onSelectDepartment(): void {
  const deptId = this.f.deptId?.value;
  if (!deptId) {
    return;
  }
    this.f.serviceIds.enable();
    this.getComponentByDeptId();
  }

  inputDate(
    type: "approvedStartDate" | "approvedEndDate" | "createdStartDate" | "createdEndDate",
    currentValue: NgbDate | null,
    input: string
  ) {
    this.form.get(type).setValue(this.validateInput(currentValue, input));
  }

  public validateInput(
    currentValue: NgbDate | null,
    input: string
  ): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  public onCreateDateSelection(date: NgbDate): void {
    if (!this.f.createdStartDate.value && !this.f.createdEndDate.value) {
      this.f.createdStartDate.setValue(date);
    } else if (
      this.f.createdStartDate.value &&
      !this.f.createdEndDate.value &&
      date &&
      (date.after(this.f.createdStartDate.value) || date.equals(this.f.createdStartDate.value))
    ) {
      this.f.createdEndDate.setValue(date);
    } else {
      this.f.createdEndDate.setValue(null);
      this.f.createdStartDate.setValue(date);
    }
  }

  public isCreateHovered(date: NgbDate): boolean {
    return (
      this.f.createdStartDate.value &&
      !this.f.createdEndDate.value &&
      this.hoveredCreatedDate &&
      date.after(this.f.createdStartDate.value) &&
      (date.before(this.hoveredCreatedDate))
    );
  }

  public isCreateInside(date: NgbDate): boolean {
    return (
      this.f.createdEndDate.value &&
      date.after(this.f.createdStartDate.value) &&
      date.before(this.f.createdEndDate.value)
    );
  }

  public isCreateRange(date: NgbDate): boolean | void {
    return (
      date.equals(this.f.createdStartDate.value) ||
      (this.f.createdEndDate.value && date.equals(this.f.createdEndDate.value)) ||
      this.isCreateInside(date) ||
      this.isCreateHovered(date)
    );
  }


  public onApproveDateSelection(date: NgbDate): void {
    if (!this.f.approvedStartDate.value && !this.f.approvedEndDate.value) {
      this.f.approvedStartDate.setValue(date);
    } else if (
      this.f.approvedStartDate.value &&
      !this.f.approvedEndDate.value &&
      date &&
      (date.after(this.f.approvedStartDate.value) || date.equals(this.f.approvedStartDate.value))
    ) {
      this.f.approvedEndDate.setValue(date);
    } else {
      this.f.approvedEndDate.setValue(null);
      this.f.approvedStartDate.setValue(date);
    }
  }

  public isApproveHovered(date: NgbDate): boolean {
    return (
      this.f.approvedStartDate.value &&
      !this.f.approvedEndDate.value &&
      this.hoveredApprovedDate &&
      date.after(this.f.approvedStartDate.value) &&
      (date.before(this.hoveredApprovedDate))
    );
  }

  public isApproveInside(date: NgbDate): boolean {
    return (
      this.f.approvedEndDate.value &&
      date.after(this.f.approvedStartDate.value) &&
      date.before(this.f.approvedEndDate.value)
    );
  }

  public isApproveRange(date: NgbDate): boolean | void {
    return (
      date.equals(this.f.approvedStartDate.value) ||
      (this.f.approvedEndDate.value && date.equals(this.f.approvedEndDate.value)) ||
      this.isApproveInside(date) ||
      this.isApproveHovered(date)
    );
  }

  public updatePageSize(size: number): void {
    this.pageSize = size;
    this.page = 1;
    this.search();
  }
  
  public updatePage(): void {
    this.getTasks();
  }

public export(): void {
  const formValue = this.form.value;

  const queryParams: { [key: string]: any } = {
    deptId: formValue.deptId,
    serviceId: formValue.serviceIds,
    createdStartDate: formValue.createdStartDate,
    createdEndDate: formValue.createdEndDate,
    approvedStartDate: formValue.approvedStartDate,
    approvedEndDate: formValue.approvedEndDate,
    aiRiskResult: formValue.aiRiskResult
  };

  Object.keys(queryParams).forEach(
    key => (queryParams[key] == null || queryParams[key] === '') && delete queryParams[key]
  );

  this._httpClient
    .get(config.exportAiRiskReport, {
      headers: { Authorization: 'Bearer ' + this.authService.token },
      responseType: 'arraybuffer',
      params: queryParams
    })
    .subscribe((response: any) => {
      const filename = 'ai-risk-assessment-report.xlsx';
      this.downloadFileService.downLoadFile(response, 'application/octet-stream', filename);
    });
  }

}
